import React from "react";

import { Button } from "rhombus-react";
import Permissioned from "widgets/Permissioned";
import { useSelector } from "react-redux";
import { IMPORT_EXPORT_ACTIONS_LIST } from "widgets/grid/cells/CreativeActionLists/VersionActions";
import { importExportActions } from "widgets/grid/cells/VersionActionLists/ImportExportActions";
import { importExportVersionsAllowables } from 'utils/VersionActions';
import { getManualClassificationEnabled } from "selectors/Intelligence";
import { TAXONOMY_VERSIONS_IMPORT_EXPORT_ACTIONS_LIST } from "widgets/actions/bulk/Taxonomy";
import { buildDropdownList } from "widgets/actions/bulk/Social";
import { MENU_DIVIDER } from "utils/constants";
import { hasPermission } from "utils/common";

export default function ImportExportButton(){
	let { user, dependentValues, canClassify } = useSelector((state)=>{
			return {
				user:state.you,
				dependentValues: {
					...state.creativeVersions,
					creativeId: state.creativeDetails?.id,
					dynamicTarget: state.creativeDetails?.dynamicTarget,
					libraryId: state.libraryProperties?.id,
					adType: state.creativeDetails.adType,
					origin: state.creativeDetails.origin,
					html5Meta: state.creativeDetails.html5Meta,
				},
				canClassify: getManualClassificationEnabled(state) && hasPermission(state.you, "Creative Library", "Edit"),
			};
		})
		, actions = importExportActions(IMPORT_EXPORT_ACTIONS_LIST, { user, dependentValues })
		, taxonomyActions = []
		;

	if (canClassify) {
		// Used buildDropdownList() since importExportActions() was adding a divider
		taxonomyActions = buildDropdownList([TAXONOMY_VERSIONS_IMPORT_EXPORT_ACTIONS_LIST], dependentValues);
		if (actions.length) {
			taxonomyActions.unshift(MENU_DIVIDER);
		}
	}

	return (
		<Permissioned any={importExportVersionsAllowables}>
			<Button
				key="import-export"
				icon="download"
				style="block"
				theme="default"
				isDropDown
				splitActions={[...actions, ...taxonomyActions]}
				splitValue="import-export-button">
				Import/Export
			</Button>
		</Permissioned>
	);
}

ImportExportButton.displayName = "ImportExportButton";
